import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IEmployeesState } from "../shared";

import { EMPLOYEES_MODULE_NAME } from "./constants";

const initialState: IEmployeesState = {
  selectedIds: [],
  searchText: "",
};
export const employeesSlice = createSlice({
  name: EMPLOYEES_MODULE_NAME,
  initialState,
  reducers: {
    setSelectedIdsAction(state, action: PayloadAction<string[]>): void {
      state.selectedIds = action.payload;
    },
    toggleId(state, action: PayloadAction<string>): void {
      const id = action.payload;
      if (state.selectedIds.includes(id)) {
        state.selectedIds = state.selectedIds.filter((item) => item !== id);
      } else {
        state.selectedIds = [id, ...state.selectedIds];
      }
    },
    setSearchText(state, action: PayloadAction<string>): void {
      state.searchText = action.payload;
    },
  },
});

export const employeesReducer = employeesSlice.reducer;
export const { setSelectedIdsAction, toggleId, setSearchText } = employeesSlice.actions;
